var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('wrapper',{staticClass:"small"},[(_vm.type==1)?[_c('p',[_c('span'),_c('br'),_c('span')])]:_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }